const NewsletterGuideIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.5 6V19.99C3.5 20.88 4.56 21.33 5.18 20.71L19.5 6.53V6C19.5 4.34 18.17 3 16.53 3H6.47C4.83 3 3.5 4.34 3.5 6Z"
      fill="#8646F2"
    />
    <path
      d="M19.5 6V19.99C19.5 20.88 18.44 21.33 17.82 20.71L3.5 6.53V6C3.5 4.34 4.83 3 6.47 3H16.53C18.17 3 19.5 4.34 19.5 6Z"
      fill="#8646F2"
    />
    <path d="M11.5 14.46L19.5 6.53003L13.37 16.3L11.5 14.46Z" fill="#6B16EE" />
  </svg>
);

export default NewsletterGuideIcon;
